import { render, staticRenderFns } from "./addEventBtn.vue?vue&type=template&id=62dd969e&scoped=true&"
import script from "./addEventBtn.vue?vue&type=script&lang=js&"
export * from "./addEventBtn.vue?vue&type=script&lang=js&"
import style0 from "./addEventBtn.vue?vue&type=style&index=0&id=62dd969e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dd969e",
  null
  
)

export default component.exports